import http from '@/http'

const BASE = '/admin/dashboard'

export const getTimeline = (params) => {
  return http.get(`${BASE}/timeline`, { params })
}

export const getStatusFunnel = (params) => {
  return http.get(`${BASE}/status-funnel`, { params })
}

export const getMetricsGrid = (params) => {
  return http.get(`${BASE}/metrics-grid`, { params })
}

export const getMetricsGridColumns = () => {
  return http.get(`${BASE}/metrics-grid/columns`)
}

export const getStatusList = () => {
  return http.get('/admin/statusPend')
}

export const getGroups = () => {
  return http.get('/admin/groups')
}

export const getFieldDistribution = (params) => {
  return http.get(`${BASE}/field-distribution`, { params })
}

export const getAvailableFields = () => {
  return http.get('/admin/participant-cards/fields/available')
}

export const getCustomGoal = () => {
  return http.get(`${BASE}/custom-goal`)
}

export const saveCustomGoal = (data) => {
  return http.post(`${BASE}/custom-goal`, data)
}

export const deleteCustomGoal = () => {
  return http.delete(`${BASE}/custom-goal`)
}

export default {
  getTimeline,
  getStatusFunnel,
  getMetricsGrid,
  getMetricsGridColumns,
  getStatusList,
  getGroups,
  getFieldDistribution,
  getAvailableFields,
  getCustomGoal,
  saveCustomGoal,
  deleteCustomGoal
}
